import { useContext } from 'react'
import * as SETTINGS from '../../../constants/settings'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import { toastError, toastSuccess } from '../../../utils/toast'
import Modal from '../../Utilities/Modal'
import PrivateMessage from '../PrivateMessage'

const HighlightModal = ({ open, setOpen, message, dispatch }) => {
  const { updateSetting } = useContext(SiteConfigContext)
  const handleHighlight = async () => {
    const response = await updateSetting(SETTINGS.HIGHLIGHTED_MESSAGE, message)

    if (response.data?.setting === SETTINGS.HIGHLIGHTED_MESSAGE.key) {
      toastSuccess('Message highlighted.')
    } else {
      toastError('Failed to highlight.')
    }
    setOpen(false)
  }

  return (
    <Modal
      title="Highlight Message"
      open={open}
      setOpen={setOpen}
      confirmFunction={handleHighlight}
      size="md"
    >
      <div className="flex flex-col gap-3 w-full">
        <PrivateMessage message={message} />
      </div>
    </Modal>
  )
}

export default HighlightModal
